import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  constructor(private title: Title) {}

  get appName(): string {
    return environment.APP_NAME;
  }

  get isSandbox(): boolean {
    return !environment.production;
  }

  get workspace(): string {
    return environment.WORKSPACE;
  }

  setDocumentTitle(): void {
    const prefixes: Record<string, string> = {
      sandbox: '[Sandbox] ',
      local: '[Local] ',
      prod: '',
    };

    const prefix = prefixes[this.workspace] ?? '';

    this.title.setTitle(`${prefix}${this.appName}`);
  }
}
